import React from 'react';
import { MapPin, Mail, Phone, Twitter, Facebook, Instagram, Linkedin } from 'lucide-react';
import { PRIVACY_POLICY_PATH } from '../App';

interface FooterProps {
  onPrivacyPolicyClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onPrivacyPolicyClick }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Sentry', href: '#' },
      { name: 'School Tripp', href: '#' },
      { name: 'Social Riding', href: '#' },
      
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Contact us', href: '#contact' },
     
    ],
    support: [           
      { name: 'Privacy Policy', href: PRIVACY_POLICY_PATH, onClick: onPrivacyPolicyClick }
    ]
  };

  const socialLinks = [
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold text-green-700 mb-4">Tripp</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Giving everyone the opportunity to manage their day better.
            </p>
            
            <div className="space-y-3">
             
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-green-700" />
                <span className="text-gray-300">+234 906 000 8700</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-green-700" />
                <span className="text-gray-300">hello@mytripp.app</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Support</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      if (link.onClick) {
                        e.preventDefault();
                        link.onClick();
                      }
                    }}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Links & Newsletter */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="flex items-center space-x-6">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-gray-400 hover:text-green-400 transition-colors duration-200"
                  aria-label={social.label}
                >
                  <social.icon className="h-6 w-6" />
                </a>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <p className="text-gray-300">Stay updated with our newsletter</p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="px-4 py-2 bg-gray-800 border border-gray-700 rounded-l-lg focus:ring-2 focus:ring-green-700 focus:border-transparent text-white placeholder-gray-400"
                />
                <button className="bg-green-700 text-white px-6 py-2 rounded-r-lg hover:bg-green-800 transition-colors duration-200">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} Tripp Platform Services. All rights reserved. 
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;